import { Injectable } from '@angular/core';
import { DateTimeService } from '@y42/date-time';
import { JobStatusCode, JobStatusCodeToStatusMap, JobUIModel } from '../../state';

@Injectable({ providedIn: 'root' })
export class AverageSyncTimeService {
  constructor(private readonly dateTimeService: DateTimeService) {}
  getAverageSyncTime(jobs: JobUIModel[]): string {
    const readyJobsDurations = jobs
      .filter((job) => JobStatusCodeToStatusMap[JobStatusCode.Ready].includes(job.status))
      .map((job) => this.getDifferenceInSeconds(job));

    const numberOfImports = readyJobsDurations.filter((jobDuration) => jobDuration > 0).length;
    const totalSyncTimeInSeconds = readyJobsDurations.reduce((acc, cur) => (acc += cur), 0);
    const averageSyncTimeInSeconds = numberOfImports > 0 ? totalSyncTimeInSeconds / numberOfImports : 0;
    const time =
      averageSyncTimeInSeconds !== 0
        ? this.dateTimeService.formatDurationShort(averageSyncTimeInSeconds, { unit: 'seconds' })
        : '/';

    return time;
  }

  getDifferenceInSeconds(job: JobUIModel) {
    return job.created_at && job.finished_at
      ? this.dateTimeService.diff(job.created_at, job.finished_at, 'seconds')
      : 0;
  }
}
